import React from 'react';
const LeaderBoardRow = ({
  employee
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "list-row list-item"
  }, /*#__PURE__*/React.createElement("p", {
    className: "name"
  }, employee.ranking, ". ", employee.name ? employee.name : employee.id), /*#__PURE__*/React.createElement("p", {
    className: "percentage"
  }, !isNaN(employee.value) ? `${Math.round(employee.value)}%` : employee.value));
};
export default LeaderBoardRow;